/* eslint-disable max-len */
import {
  CENTRAL_SETTINGS_GET_URL,
  CENTRAL_SETTINGS_UPDATE_URL,
  ADD_SELLER_URL,
  UPDATE_SELLER_DATA_PROVIDERS_URL,
  DELETE_SELLER_URL,
} from '@1po/1po-bff-fe-spec/generated/backoffice/BackofficeURLs';
import { AddSellerRequest } from '@1po/1po-bff-fe-spec/generated/backoffice/central_settings/request/AddSellerRequest';
import { CentralSettingsUpdateRequest } from '@1po/1po-bff-fe-spec/generated/backoffice/central_settings/request/CentralSettingsUpdateRequest';
import { DeleteSellerRequest } from '@1po/1po-bff-fe-spec/generated/backoffice/central_settings/request/DeleteSellerRequest';
import { UpdateSellerDataProvidersRequest } from '@1po/1po-bff-fe-spec/generated/backoffice/central_settings/request/UpdateSellerDataProvidersRequest';
import {
  ADD_SELLER_RESPONSE,
  BACKOFFICE_GET_CENTRAL_SETTINGS_RESPONSE,
  BACKOFFICE_UPDATE_CENTRAL_SETTINGS_RESPONSE,
  DELETE_SELLER_RESPONSE,
  UPDATE_SELLER_DATA_PROVIDERS_RESPONSE,
} from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import { RequestResponseMappingManager } from 'domains/webSockets/WebSocket.requestsResponseMapping';
import { WebSocketAction } from 'utils';
import { wsSendAction } from 'utils/domainStore/api';

// Register request-response mappings
RequestResponseMappingManager.addMapping(CENTRAL_SETTINGS_GET_URL, BACKOFFICE_GET_CENTRAL_SETTINGS_RESPONSE);
RequestResponseMappingManager.addMapping(CENTRAL_SETTINGS_UPDATE_URL, BACKOFFICE_UPDATE_CENTRAL_SETTINGS_RESPONSE);
RequestResponseMappingManager.addMapping(ADD_SELLER_URL, ADD_SELLER_RESPONSE);
RequestResponseMappingManager.addMapping(UPDATE_SELLER_DATA_PROVIDERS_URL, UPDATE_SELLER_DATA_PROVIDERS_RESPONSE);
RequestResponseMappingManager.addMapping(DELETE_SELLER_URL, DELETE_SELLER_RESPONSE);

export function sendGetCentralSettings(): WebSocketAction {
  return wsSendAction(CENTRAL_SETTINGS_GET_URL, null);
}

export function sendUpdateCentralSettings(payload: CentralSettingsUpdateRequest): WebSocketAction {
  return wsSendAction(CENTRAL_SETTINGS_UPDATE_URL, payload);
}

export function sendAddSeller(payload: AddSellerRequest): WebSocketAction {
  return wsSendAction(ADD_SELLER_URL, payload);
}

export function sendUpdateSellerDataProviders(payload: UpdateSellerDataProvidersRequest): WebSocketAction {
  return wsSendAction(UPDATE_SELLER_DATA_PROVIDERS_URL, payload);
}

export function sendDeleteSeller(payload: DeleteSellerRequest): WebSocketAction {
  return wsSendAction(DELETE_SELLER_URL, payload);
}
